module.exports = __webpack_public_path__ + "static/media/quote-smith-qualified-fr.16b71ce0.png";